import DOMPurify from 'dompurify'

function renderLegendHtml(legendArray) {
  if (!Array.isArray(legendArray))
    return '<ul class="gf-calendar-legend-list"></ul>'
  const items = legendArray.map((item) => {
    const icon = DOMPurify.sanitize(item.iconHtml || '', {
      ALLOWED_TAGS: ['i', 'span'],
      ALLOWED_ATTR: ['class'],
    })
    const label = DOMPurify.sanitize(item.label || '')
    return `<li class="gf-calendar-legend-item"><span class="gf-fc-legend-icon">${icon}</span><span class="gf-fc-event-legend-text">${label}</span></li>`
  })
  return `<ul class="gf-calendar-legend-list">${items.join('')}</ul>`
}

function ensureLegendPanel(calendarElement, legendArray) {
  let panel = document.getElementById('gf-calendar-legend')
  if (panel)
    return panel

  panel = document.createElement('div')
  panel.id = 'gf-calendar-legend'
  panel.className = 'gf-calendar-legend open' // start with the panel open
  panel.innerHTML = renderLegendHtml(legendArray)

  const legendButton = calendarElement.querySelector('.fc-keyLegend-button')
  const legendIcon = calendarElement.querySelector(
    '.fc-keyLegend-button .gf-fc-legend-icon, .fc-keyLegend-button .fc-icon.legend-icon',
  )

  // Prefer inserting after the icon (sibling), fall back to appending to the button, then calendar root
  if (legendIcon && legendIcon.parentNode)
    legendIcon.insertAdjacentElement('afterend', panel)
  else if (legendButton)
    legendButton.appendChild(panel)
  else
    calendarElement.appendChild(panel)

  return panel
}

function updateLegendContent(legendArray) {
  const panel = document.getElementById('gf-calendar-legend')
  if (!panel)
    return
  panel.innerHTML = renderLegendHtml(legendArray)
}

function toggleLegendPanel(calendarElement, legendArray) {
  const panel
    = document.getElementById('gf-calendar-legend')
    || ensureLegendPanel(calendarElement, legendArray)
  if (!panel)
    return
  panel.classList.toggle('open')
}

export {
  ensureLegendPanel,
  updateLegendContent,
  toggleLegendPanel,
}
